import React, { Component } from "react";
import SectionFooter from "./sectionfooter";

class Impressum extends Component {
  render() {
    return (
      <section id="about-us">
        <h1>Impressum</h1>
        <br />
        <h3>Haftungsausschluss</h3>
        <div className="primary">
          <p className="intro">
            Die Tambour Korps "Blau-Weiß" Hartegasse &uuml;bernimmt keinerlei
            Gew&auml;hr f&uuml;r die Aktualit&auml;t, Korrektheit,
            Vollst&auml;ndigkeit oder Qualit&auml;t der bereitgestellten
            Informationen. Haftungsanspr&uuml;che gegen die Tambour Korps
            "Blau-Weiß" Hartegasse, die sich auf Sch&auml;den materieller oder
            ideeller Art beziehen, welche durch die Nutzung oder Nichtnutzung
            der dargebotenen Informationen bzw. durch die Nutzung fehlerhafter
            und unvollst&auml;ndiger Informationen verursacht wurden, sind
            grunds&auml;tzlich ausgeschlossen, sofern seitens der Tambour Korps
            "Blau-Weiß" Hartegasse kein nachweislich vors&auml;tzliches oder
            grob fahrl&auml;ssiges Verschulden vorliegt.
          </p>
          <p className="intro">
            Alle Angebote sind freibleibend und unverbindlich. Die Tambour Korps
            "Blau-Weiß" Hartegasse beh&auml;lt es sich ausdr&uuml;cklich vor,
            Teile der Seiten oder das gesamte Angebot ohne gesonderte
            Ank&uuml;ndigung zu ver&auml;ndern, zu erg&auml;nzen, zu
            l&ouml;schen oder die Ver&ouml;ffentlichung zeitweise oder
            endg&uuml;ltig einzustellen.
          </p>

          <h3>Verweise und Links</h3>
          <p className="intro">
            Wir haben die Inhalte der von uns gelinkten Seiten sorgf&auml;ltig
            &uuml;berpr&uuml;ft und f&uuml;r gut befunden. Sollten sich in der
            Zwischenzeit &Auml;nderungen mit rechtswidrigen, beleidigenden oder
            sonstwie fragw&uuml;rdigen Inhalten ergeben haben, bitten wir um
            eine kurze Nachricht.
          </p>
          <p className="intro">
            Eine Gew&auml;hr oder jegliche Haftung f&uuml;r Link-Verweise und
            insbesondere die Informationen der verlinkten Internetseiten von
            Drittanbietern, die außerhalb des Verantwortungsbereiches der
            Tambour Korps "Blau-Weiß" Hartegasse liegen, kann nicht
            &uuml;bernommen werden. Die Rechte an diesen Seiten sowie die
            Verantwortlichkeit f&uuml;r deren Inhalt liegen ausschließlich beim
            Drittanbieter.
          </p>

          <h3>Urheberrecht</h3>
          <p className="intro">
            Das Urheberrecht (Copyright) f&uuml;r ver&ouml;ffentlichte, von der
            Tambour Korps "Blau-Weiß" Hartegasse selbst erstellte Inhalte bleibt
            allein bei der Tambour Korps "Blau-Weiß" Hartegasse. Eine
            Vervielf&auml;ltigung oder Verwendung solcher Inhalte (insbesondere
            Grafiken, Dokumente und Texte) in anderen elektronischen oder
            gedruckten Publikationen ist ohne ausdr&uuml;ckliche Zustimmung der
            Tambour Korps "Blau-Weiß" Hartegasse nicht gestattet.
          </p>
          <p className="intro">
            Das Seitenlayout (Design) stammt von{" "}
            <a href="http://www.styleshout.com/">styleshout</a>
            und wird unter der{" "}
            <a
              href="https://creativecommons.org/licenses/by/2.5/"
              rel="license"
            >
              Creative Commons Attribution 3.0 License
            </a>{" "}
            verwendet. Wir danken f&uuml;r die freundliche Bereitstellung der
            Vorlagen (Templates).
          </p>
        </div>
        <SectionFooter />
      </section>
    );
  }
}

export default Impressum;



// WEBPACK FOOTER //
// ./src/components/impressum.js